<ngx-skeleton-loader [count]="1" [appearance]="appearance" [theme]="theme"></ngx-skeleton-loader>